import { createContext, useContext, useMemo } from 'react'
import { useLanguage } from './LanguageContext'
import { usePublicPageContent } from '../hooks/usePublicPageContent'
import { sectionOf } from '../utils/cms'

const SiteContentContext = createContext(null)

export function SiteContentProvider({ children }) {
  const { language } = useLanguage()
  const { page, loading } = usePublicPageContent('home', language)

  const value = useMemo(
    () => ({
      homePage: page,
      loading,
      navbar: sectionOf(page, 'navbar'),
      footer: sectionOf(page, 'footer'),
      whatsNext: sectionOf(page, 'whats-next'),
    }),
    [page, loading]
  )

  return (
    <SiteContentContext.Provider value={value}>
      {children}
    </SiteContentContext.Provider>
  )
}

export function useSiteContent() {
  const ctx = useContext(SiteContentContext)
  if (!ctx) {
    throw new Error('useSiteContent must be used within SiteContentProvider')
  }
  return ctx
}
